import config from '../config'

export const spookyNavMixin = {
  methods: {
    doSpookyNav(routeName, routeParams, line1, line2) {
      this.$modal.show('state-change-overlay', {
        line1: line1,
        line2: line2
      })

      setTimeout(() => {
        this.$router.push({
          name: routeName,
          params: routeParams
        })
      }, config.delayBeforeNavigate)
    }
  }
}
